class MobileDock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');

    this.isAction = false;
    this.activeButton = null;
    this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;

    if (Shopify && Shopify.designMode) {
      this.scrollY = 0;
    }

    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.onActionCloseHandler = this.onActionClose.bind(this);

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClickHandler);
    });
    document.addEventListener('menudrawer:close', this.onActionCloseHandler);
    document.addEventListener('searchmodal:close', this.onActionCloseHandler);

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();

    document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    document.addEventListener('matchSmall', () => {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.removeEventListener('click', this.onButtonClickHandler);
    });
    document.removeEventListener('menudrawer:close', this.onActionCloseHandler);
    document.removeEventListener('searchmodal:close', this.onActionCloseHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.scrollY) {
      this.classList.add('is-active');
    }
    else {
      this.classList.remove('is-active');
    }
  }

  onButtonClick(event) {
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    this.setActiveButton(target);

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const cartToggle = document.querySelector('cart-drawer details > summary');
        if (cartToggle) {
          setTimeout(() => {
            cartToggle.click();
          }, delay);
        }
        else {
          window.location.href = theme.routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const menuToggle = document.querySelector('header-drawer details > summary');
        if (menuToggle) {
          setTimeout(() => {
            menuToggle.click();
          }, delay);
        }
        else {
          this.resetActiveButton();
        }
        break;

      case 'search':
        this.isAction = true;

        const searchModal = Array.from(document.querySelectorAll('search-modal')).find((modal) => {
          return window.getComputedStyle(modal).display !== 'none';
        });
        const searchToggle = searchModal?.querySelector('details > summary');

        if (searchToggle) {
          setTimeout(() => {
            searchToggle.click();
          }, delay);
        }
        else {
          window.location.href = theme.routes.search_url;
        }
        break;
    }
  }

  setActiveButton(button) {
    this.resetActiveButton();
    this.activeButton = button;
    this.activeButton.setAttribute('aria-expanded', 'true');
  }

  resetActiveButton({ restoreFocus = false } = {}) {
    if (!this.activeButton) return;

    const button = this.activeButton;
    button.setAttribute('aria-expanded', 'false');
    this.activeButton = null;

    if (restoreFocus) button.focus();
  }

  onActionClose() {
    if (!this.activeButton) return;

    const focusDelay = this.hideStickyHeader();
    setTimeout(() => this.resetActiveButton({ restoreFocus: true }), focusDelay);
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return 0;

    if (theme.config.mqlSmall && this.isAction && header.sticky()) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);

      return 500;
    }

    this.isAction = false;
    return 0;
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (!header.sticky() && !this.isElementVisible(header)) {
      header.hide();
      setTimeout(() => header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
customElements.define('mobile-dock', MobileDock);
